module.exports = __webpack_public_path__ + "static/media/tv.313f350d.svg";